import { render, staticRenderFns } from "./TreeSelect.vue?vue&type=template&id=1e4bc245&"
import script from "./TreeSelect.vue?vue&type=script&lang=js&"
export * from "./TreeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports